import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('receivingOfCultivatedAbolone', 'receivingOfCultivatedAbolones');

const customActions = {
  async LOAD_receivingOfCultivatedAbolones({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('receivingOfCultivatedAbolones')
      .query({ $filter: 'IsDeleted eq false', $expand: 'StockItem($expand=DeliveryNote)' });
    commit('SET_receivingOfCultivatedAbolones', data);
    return data;
  },
};

export default { ...actions, ...customActions };
